module.exports = __webpack_public_path__ + "static/media/icon_assine.34450b74.svg";